import { z as userInfoStore } from '../../../loadingStore-a389b52a.js';
import '../store/chatStore.js';
import '../store/wageringStore.js';
import '../store/roundInfoStore.js';
import '../store/userCountStore.js';
import '../store/gameResultStore.js';
import '../store/resultHashStore.js';
import '../store/userWinBetsStore.js';
import '../store/notificationStore.js';
import '../store/selectedResultInfoStore.js';
import '../enums/GameSpecificTypes.js';
import '../enums/MaxPayoutDataTypes.js';
import '../enums/Chat.js';
import '../enums/GameModes.js';
import '../enums/IconTypes.js';
import '../enums/BetStatus.js';
import { Currencies } from '../enums/Currencies.js';
import '../enums/PopupTypes.js';
import '../enums/ApiVersion.js';
import '../enums/RoundStatus.js';
import '../enums/FreeBetsStatus.js';
import '../enums/SocketEvents.js';
import '../enums/TranslationKeys.js';
import '../enums/TimeoutMaxValue.js';
import '../enums/ApiServiceTypes.js';
import '../enums/EnvironmentTypes.js';
import '../enums/DefaultQueryValues.js';
import '../enums/FreeBetWinningType.js';
import '../enums/DefaultQueryParams.js';
import '../enums/BetHistoryFilterTypes.js';
import '../enums/GameThemeTypes.js';
import '../enums/RequestStatus.js';
import '../enums/FetchDefaultPaths.js';
import '../enums/ResponseCodes.js';
import '../../../tslib.es6-14c74580.js';
import 'mobx';
import '@microsoft/signalr';
import '../services/liveConnection/types.js';
import '../classes/httpResponse/index.js';
import './environmentBuilder.js';
import '../enums/BogLineGameConfig.js';
import './parseQuery.js';
import 'axios';
import '../services/sound/types.js';
import '../services/sound/SoundService.js';
import 'howler';
import '../services/sound/defaultSounds.js';
import '../services/api/types.js';
import '../services/api/BaseApiService.js';
import '../enums/StatisticsSortingTypes.js';
import '../services/ApiServices.js';
import '../polyfill.js';
import '../../../_commonjsHelpers-1a7a244d.js';
import '../../../momentFormat-14fce7b4.js';
import '../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../table-line/t_types/enums/PopupTypes.js';
import './formatDate.js';
import './updateHalfBets.js';
import '../enums/bogGameNames.js';

var getAmountWithCurrency = function (_a) {
    var _b;
    var amount = _a.amount, isReturnPreValue = _a.isReturnPreValue, isShowRealCurrency = _a.isShowRealCurrency, withSpace = _a.withSpace, isShowWithoutChange = _a.isShowWithoutChange;
    var currencySymbolOrCode = userInfoStore.currencySymbolOrCode, realCurrencyCode = userInfoStore.realCurrencyCode, currencyCode = userInfoStore.currencyCode, realCurrencySymbolOrCode = userInfoStore.realCurrencySymbolOrCode;
    var currency = isShowRealCurrency ? realCurrencySymbolOrCode : currencySymbolOrCode;
    var pre = (_b = Currencies[(isShowRealCurrency ? realCurrencyCode : currencyCode).toUpperCase()]) === null || _b === void 0 ? void 0 : _b.pre;
    return isReturnPreValue
        ? pre
        : !pre || isShowWithoutChange
            ? "".concat(amount).concat(withSpace ? ' ' : '').concat(currency)
            : "".concat(currency).concat(withSpace ? ' ' : '').concat(amount);
};

export { getAmountWithCurrency };
